import { collectionEngineV1 } from '../apis.js';
import { toQuery } from '@debbie/common/dist/util/index.js';
const reqV1 = collectionEngineV1('/properties');
export const historical = (ref, refId, handle) => reqV1('GET', `/${ref}/${refId}/${handle}/history`);
export const get = (p, casualConsistency) => reqV1('GET', `/${p.ref}/${p.refId}?${toQuery({
    scope: p.scope || undefined,
    scopeId: p.scopeId || undefined,
    casualConsistency: casualConsistency ? true : undefined,
})}`);
export const getTypes = () => reqV1('GET', '/types');
export const createType = (data) => reqV1('POST', '/types', {
    body: {
        ref: data.ref,
        scope: data.scope,
        scopeId: data.scopeId,
        data: data.data,
        description: data.description,
        handle: data.handle,
        label: data.label,
        permissionLevel: data.permissionLevel,
        permissionLevelEdit: data.permissionLevelEdit,
        required: data.required,
        type: data.type,
    },
});
export const patchType = (propertyTypeId, patch) => reqV1('PATCH', `/types/${propertyTypeId}`, {
    body: patch,
});
export const update = (data) => reqV1('PATCH', `/${data.ref}/${data.refId}/${data.handle}`, {
    body: {
        data: data.data,
        type: data.type,
    },
});
export const delType = (propertyTypeId) => reqV1('DELETE', `/types/${propertyTypeId}`);
//# sourceMappingURL=properties.js.map